import { Trigger as CollapsibleTrigger } from "@radix-ui/react-collapsible";
import { cx } from "@suse-o11y/class-variance";
import React from "react";

export type TriggerProps = React.ComponentPropsWithoutRef<typeof CollapsibleTrigger>;

export const Trigger = React.forwardRef<React.ComponentRef<typeof CollapsibleTrigger>, TriggerProps>(
	({ asChild, className, type, ...props }, ref) => (
		<CollapsibleTrigger
			{...props}
			asChild={asChild}
			className={cx("suse-o11y/collapsible-trigger", className)}
			ref={ref}
			type={type ?? (asChild ? undefined : "button")}
		/>
	),
);

Trigger.displayName = "Collapsible.Trigger";
